import React, { useState } from 'react';
import ReactPlayer from 'react-player';
import styled from '@emotion/styled';
import { baseTransitionSecond, grayscaleFilter, isIe } from 'style/variables';
import icon from 'assets/images/icons/icon-play.svg';
import { StaticQuery, graphql } from 'gatsby';
type ContainerProps = {
  aspectRation?: '720 / 1280' | '431 / 572' | '655 / 1160';
};

type VideoProps = {
  url: string;
} & ContainerProps;

const Container = styled.div<ContainerProps>`
  position: relative;
  &::before {
    content: '';
    display: block;
    padding-top: calc(${props => props.aspectRation} * 100%);
  }
  & > div {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
`;

const Btn = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 31px;
  height: 31px;
  margin: auto;
  opacity: 0.8;
  background-image: url(${icon});
  background-size: contain;
  transition: opacity ${baseTransitionSecond}s ease;
  mix-blend-mode: exclusion;
  ${isIe} {
  }
  &:hover {
    animation: hover ${baseTransitionSecond * 2}s ease;
    @keyframes hover {
      0% {
        transform: scale3d(1, 1, 1);
      }
      50% {
        transform: scale3d(1.08, 1.08, 1);
      }
      100% {
        transform: scale3d(1, 1, 1);
      }
    }
  }
  .is-playing & {
    opacity: 0;
    pointer-events: none;
  }
`;

export const Video: React.FC<VideoProps> = ({ aspectRation = '720 / 1280', ...props }) => {
  const [playing, setPlaying] = useState(false);
  const play = (isPlay: boolean) => {
    setPlaying(!isPlay);
  };

  if (props.url.includes('http')) {
    return (
      <Container
        className={playing ? 'is-playing' : 'is-pausing'}
        onClick={() => playing && play(playing)}
        aspectRation={aspectRation}
      >
        <ReactPlayer
          url={props.url}
          playing={playing}
          width={'100%'}
          height={'100%'}
          muted
          playsinline
          loop={true}
          onReady={() => play(playing)}
        />
        <Btn onClick={() => play(playing)} />
      </Container>
    );
  }

  return (
    <StaticQuery
      query={graphql`
        query {
          videos: allFile(filter: { extension: { eq: "mp4" } }) {
            edges {
              node {
                relativePath
                name
                publicURL
                url
              }
            }
          }
        }
      `}
      render={data => {
        const video = data.videos.edges.find(n => {
          return n.node.relativePath.includes(props.url) || n.node.url?.includes(props.url);
        });
        const src = video?.node?.publicURL;
        if (!video || !src) {
          return null;
        }
        return (
          <Container
            className={playing ? 'is-playing' : 'is-pausing'}
            onClick={() => playing && play(playing)}
            aspectRation={aspectRation}
          >
            <ReactPlayer
              url={src}
              playing={playing}
              width={'100%'}
              height={'100%'}
              // style={{
              //   filter: grayscaleFilter,
              // }}
              muted
              playsinline
              loop={true}
              onReady={() => play(playing)}
              onPlay={() => setPlaying(true)}
            />
            <Btn onClick={() => play(playing)} />
          </Container>
        );
      }}
    />
  );
};
